import React, { useEffect, useState } from "react"
import { withOrientationChange } from "react-device-detect"
import { sanitizeInnerHtml, getShortenedUrl } from "@/utils/helper"

import Button from "@/components/core/Button/Button"

const FormSuccessMessage = props => {
  const [continueUrl, setContinueUrl] = useState("")
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    })
  }, [])

  const getContinueUrl = async () => {
    try {
      setContinueUrl(await getShortenedUrl(props?.continueShoppingUrl, true))
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getContinueUrl()
  }, [props?.continueShoppingUrl])

  return (
    <div className="lead-gen-confirmation-message-wrapper">
      <div className="lead-gen-confirmation-message__container">
        <div
          id="lead-gen-success-message"
          className="message-content"
          tabIndex="0"
        >
          <p className="success-message-title">
            {sanitizeInnerHtml(props.i18n.successTitle)}
          </p>
          <p className="success-message-description">
            {sanitizeInnerHtml(props.i18n.successDescription)}
          </p>
        </div>
        <div className="lead-gen-response-message__cta">
          <Button
            type="black"
            target={props?.isNewTab ? "_blank" : "_self"}
            label={props.i18n.startShopping}
            to={continueUrl}
            className="start-shopping-btn"
          />
        </div>
      </div>
    </div>
  )
}

export default withOrientationChange(FormSuccessMessage)
